import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography,
    Box,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ErrorDialogProps {
    open: boolean;
    errorMessage: string; // The error message to display
    onClose: () => void; // Function to handle dialog closure
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
    open,
    errorMessage,
    onClose,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    padding: 3,
                    textAlign: "center",
                },
            }}
            className="force-dynamic-translation"
        >
            <DialogTitle>
                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <ErrorOutlineIcon fontSize="large" color="error" />
                    <Typography fontWeight={700} fontSize="18px" color="error">
                        Error Occurred
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Box mt={2}>
                    <Typography
                        fontWeight={400}
                        fontSize="16px"
                        lineHeight="22px"
                        color="text.secondary"
                    >
                        {errorMessage}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="error"
                    sx={{
                        borderRadius: "12px",
                        padding: "8px 16px",
                        fontWeight: 500,
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialog;
